module.exports = __webpack_public_path__ + "static/media/google.d9cd1bec.svg";